// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bd428de","455":"24255522","830":"286aee42","977":"a6916a33"}[chunkId] + ".chunk.js";
};